(function () {
  "use strict";
  var script = document.currentScript || document.querySelector("script[src*='popup.js']");
  var donnees = (script && script.dataset) || {};

  var CONFIG = {
    photo: donnees.photo || "",
    alt: "Buffet en chêne dans un salon lumineux",
    code: "",
    donnees: donnees.donnees || "/pages/donnees-personnelles",
    pagesExclues: /^\/(pages|policies)\//i,
    minSurPage: 3500,
    ongletMobilePage1: 0.4,
    joursApres1: 7,
    joursApres2: 30,
    joursOnglet: 14,
    joursOngletMasque: 30,
    delaiSession: 15000,
    defilementRegle: 0.3,
  };
  var JOUR = 86400000;

  if (CONFIG.pagesExclues.test(location.pathname)) return;
  if (window.__mdsPopup) return;
  window.__mdsPopup = true;

  function lire(cle, defaut, stock) {
    try {
      var v = (stock || localStorage).getItem(cle);
      return v ? JSON.parse(v) : defaut;
    } catch (e) {
      return defaut;
    }
  }
  function ecrire(cle, val, stock) {
    try {
      (stock || localStorage).setItem(cle, JSON.stringify(val));
    } catch (e) {}
  }
  var sess = (function () {
    try {
      return window.sessionStorage;
    } catch (e) {
      return null;
    }
  })();
  var etat = lire("mds-popup", {}) || {};
  function garder() {
    ecrire("mds-popup", etat);
  }
  var session = (sess && lire("mds-popup-session", null, sess)) || { debut: Date.now(), pages: 0, ouvert: false };
  session.pages++;
  function garderSession() {
    if (sess) ecrire("mds-popup-session", session, sess);
  }
  garderSession();

  function dejaInscrit() {
    if (etat.inscrit) return true;
    var l = lire("mds-inscrits", []);
    return Array.isArray(l) && l.length > 0;
  }
  if (dejaInscrit()) return;

  var mobile = window.matchMedia("(max-width: 767px)");
  var reduit = window.matchMedia("(prefers-reduced-motion: reduce)");
  var debutPage = Date.now();

  function el(tag, attrs, html) {
    var n = document.createElement(tag);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    if (html != null) n.innerHTML = html;
    return n;
  }
  var voile = el("div", { class: "newsletter-popup-overlay", hidden: "" });
  var boite = el(
    "div",
    {
      class: "newsletter-popup",
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": "mp-titre",
      "aria-describedby": "mp-desc",
      hidden: "",
    },
    '<button class="newsletter-popup__close" type="button" aria-label="Fermer"><i class="ph ph-x" aria-hidden="true"></i></button>' +
      '<figure class="newsletter-popup__media"><img src="' +
      CONFIG.photo +
      '" alt="' +
      CONFIG.alt +
      '" decoding="async" loading="lazy"></figure>' +
      '<div class="newsletter-popup__body">' +
      '<div class="newsletter-popup__step newsletter-popup__step--offer">' +
      '<h2 class="newsletter-popup__title newsletter-popup__title--offer" id="mp-titre"><span class="newsletter-popup__amount">30 €</span> offerts</h2>' +
      '<p class="newsletter-popup__text" id="mp-desc">Sur votre première commande, dès 500 €.</p>' +
      '<button class="newsletter-popup__button newsletter-popup__next" type="button">Recevoir mon code</button>' +
      '<form class="newsletter-popup__form" novalidate>' +
      '<label class="visually-hidden" for="mp-email">Votre adresse email</label>' +
      '<input class="newsletter-popup__input" id="mp-email" name="email" type="email" inputmode="email" autocomplete="email" autocapitalize="off" spellcheck="false" placeholder="prenom@exemple.fr" aria-describedby="mp-erreur mp-mention" required>' +
      '<p class="newsletter-popup__error" id="mp-erreur" role="alert"></p>' +
      '<button class="newsletter-popup__button" type="submit">Recevoir mon code</button>' +
      '<p class="newsletter-popup__legal" id="mp-mention">En demandant le code, vous acceptez de recevoir les emails de Magie du Salon : trois la première semaine, puis un par mois. Désinscription à tout moment par le lien présent dans chaque email. <a href="' +
      CONFIG.donnees +
      '">Vos données et vos droits</a></p>' +
      "</form>" +
      "</div>" +
      '<div class="newsletter-popup__step newsletter-popup__step--success" hidden>' +
      '<p class="newsletter-popup__eyebrow">Inscription confirmée</p>' +
      '<h2 class="newsletter-popup__title" id="mp-titre-merci" tabindex="-1">Votre code arrive par email</h2>' +
      '<div class="newsletter-popup__code"><output id="mp-code-valeur" aria-label="Code de réduction">Envoyé à votre adresse email</output><button class="newsletter-popup__copy" type="button" hidden><i class="ph ph-copy" aria-hidden="true"></i><span>Copier</span></button></div>' +
      '<p class="newsletter-popup__condition"><b>30 €</b> de remise dès 500 € d\'achat, sur votre première commande, une seule fois par client.</p>' +
      '<p class="newsletter-popup__text">Il arrive dans la minute. Regardez aussi dans vos courriers indésirables, puis saisissez-le à l\'étape du paiement.</p>' +
      '<button class="newsletter-popup__button newsletter-popup__button--dark newsletter-popup__continue" type="button">Continuer mes achats</button>' +
      '<p class="visually-hidden" role="status" aria-live="polite" id="mp-annonce"></p>' +
      "</div>" +
      "</div>",
  );
  var onglet = el(
    "div",
    { class: "newsletter-popup-tab", hidden: "" },
    '<button class="newsletter-popup-tab__open" type="button" aria-haspopup="dialog"><i class="ph ph-gift" aria-hidden="true"></i><span>30 € offerts dès 500 €</span></button>' +
      '<button class="newsletter-popup-tab__close" type="button" aria-label="Masquer l\'offre"><i class="ph ph-x" aria-hidden="true"></i></button>',
  );

  function monter() {
    if (voile.parentNode) return;
    document.body.appendChild(voile);
    document.body.appendChild(boite);
    document.body.appendChild(onglet);
  }

  var $ = function (s) {
    return boite.querySelector(s);
  };
  var form = $(".newsletter-popup__form"),
    champ = $("#mp-email"),
    erreur = $("#mp-erreur");
  var offre = $(".newsletter-popup__step--offer"),
    merci = $(".newsletter-popup__step--success"),
    copier = $(".newsletter-popup__copy");
  var ouverte = false,
    avant = null,
    fermeture = null;

  function signal(action) {
    try {
      document.dispatchEvent(new CustomEvent("mds:popup", { detail: { action: action } }));
    } catch (e) {}
    try {
      if (window.dataLayer) window.dataLayer.push({ event: "mds_popup", action: action });
    } catch (e) {}
  }

  function bloque() {
    if (document.querySelector(".drawer.is-open")) return true;
    if (document.body.classList.contains("has-open-drawer")) return true;
    if (document.querySelector(".wall-viewer.is-open, .lightbox.is-open, .cookie-banner.is-open")) return true;
    var vi = document.querySelector(".lightbox");
    if (vi && !vi.hidden) return true;
    var a = document.activeElement;
    if (a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) && !boite.contains(a)) return true;
    return false;
  }

  function focaliser(n) {
    try {
      n.focus({ preventScroll: true });
    } catch (e) {
      n.focus();
    }
  }

  function ouvrir(origine) {
    if (ouverte || etat.inscrit) return;
    monter();
    ouverte = true;
    clearTimeout(fermeture);
    avant = document.activeElement;
    var compact = mobile.matches && origine !== "onglet";
    boite.classList.toggle("newsletter-popup--compact", compact);
    cacherOnglet();
    voile.hidden = false;
    boite.hidden = false;
    document.documentElement.classList.add("has-open-popup");
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        voile.classList.add("is-visible");
        boite.classList.add("is-visible");
      });
    });
    var cible = compact ? $(".newsletter-popup__next") : champ;
    setTimeout(
      function () {
        focaliser(cible);
      },
      reduit.matches ? 0 : 60,
    );
    if (origine !== "onglet") {
      session.ouvert = true;
      garderSession();
    }
    etat.vues = (etat.vues || 0) + 1;
    garder();
    signal("vue:" + origine);
  }

  function fermer(raison) {
    if (!ouverte) return;
    ouverte = false;
    voile.classList.remove("is-visible");
    boite.classList.remove("is-visible");
    document.documentElement.classList.remove("has-open-popup");
    fermeture = setTimeout(
      function () {
        voile.hidden = true;
        boite.hidden = true;
      },
      reduit.matches ? 0 : 450,
    );
    if (!etat.inscrit) {
      etat.fermetures = (etat.fermetures || 0) + 1;
      etat.fermeLe = Date.now();
      etat.revoir = Date.now() + (etat.fermetures >= 2 ? CONFIG.joursApres2 : CONFIG.joursApres1) * JOUR;
      garder();
      montrerOnglet(true);
    }
    if (avant && avant.focus && avant !== document.body && document.contains(avant)) focaliser(avant);
    else if (!onglet.hidden) focaliser(onglet.querySelector(".newsletter-popup-tab__open"));
    signal("fermeture:" + raison);
  }

  function ongletPermis() {
    return !etat.inscrit;
  }
  function reduireOnglet(anime) {
    var ouvrirBtn = onglet.querySelector(".newsletter-popup-tab__open");
    onglet.classList.toggle("is-anime", !!anime);
    onglet.classList.add("is-reduit");
    ouvrirBtn.setAttribute("aria-label", "30 € offerts dès 500 €");
  }
  function montrerOnglet(force) {
    if (!ongletPermis()) return;
    if (!force && !(etat.fermeLe && Date.now() < etat.fermeLe + CONFIG.joursOnglet * JOUR)) return;
    monter();
    if (etat.ongletReduit || etat.ongletMasque) reduireOnglet(false);
    onglet.hidden = false;
    placerOnglet();
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        onglet.classList.add("is-visible");
      });
    });
  }
  function cacherOnglet() {
    onglet.classList.remove("is-visible");
    onglet.hidden = true;
  }
  function placerOnglet() {
    var barre = document.querySelector(".sticky-buy-bar.is-visible");
    var h = barre ? barre.offsetHeight : 0;
    document.documentElement.style.setProperty("--newsletter-popup-tab-offset", h + "px");
  }
  var barreAchat = document.querySelector(".sticky-buy-bar");
  if (barreAchat && window.MutationObserver)
    new MutationObserver(placerOnglet).observe(barreAchat, { attributes: true, attributeFilter: ["class"] });

  function inscrireShopify(email) {
    var champs = {
      form_type: "customer",
      utf8: "✓",
      "contact[email]": email,
      "contact[tags]": "newsletter,popup",
      "contact[accepts_marketing]": "true",
    };
    var fd = new FormData();
    Object.keys(champs).forEach(function (k) {
      fd.append(k, champs[k]);
    });
    var racine = (window.MDS && window.MDS.racine) || "/";
    fetch(racine.replace(/\/$/, "") + "/contact#mp", { method: "POST", body: fd, credentials: "same-origin" })
      .then(function (r) {
        if (!/challenge/.test(r.url)) return;
        var f = document.createElement("form");
        f.method = "post";
        f.action = racine.replace(/\/$/, "") + "/contact";
        f.hidden = true;
        Object.keys(champs).forEach(function (k) {
          var i = document.createElement("input");
          i.type = "hidden";
          i.name = k;
          i.value = champs[k];
          f.appendChild(i);
        });
        document.body.appendChild(f);
        setTimeout(function () {
          f.submit();
        }, 2500);
      })
      .catch(function () {});
  }

  var motif = /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i;
  function montrerErreur(msg) {
    erreur.innerHTML = '<i class="ph ph-warning-circle" aria-hidden="true"></i><span>' + msg + "</span>";
    champ.setAttribute("aria-invalid", "true");
    champ.focus();
  }
  champ.addEventListener("input", function () {
    if (champ.getAttribute("aria-invalid") === "true" && motif.test(champ.value.trim())) {
      champ.removeAttribute("aria-invalid");
      erreur.textContent = "";
    }
  });
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    var v = champ.value.trim();
    if (!v) return montrerErreur("Indiquez votre adresse email pour recevoir le code.");
    if (!motif.test(v)) return montrerErreur("Cette adresse semble incomplète. Exemple : prenom@exemple.fr");
    champ.removeAttribute("aria-invalid");
    erreur.textContent = "";
    var liste = lire("mds-inscrits", []);
    if (!Array.isArray(liste)) liste = [];
    liste.push({ date: Date.now(), source: "popup" });
    ecrire("mds-inscrits", liste);
    inscrireShopify(v);
    etat.inscrit = true;
    etat.inscritLe = Date.now();
    garder();
    offre.hidden = true;
    merci.hidden = false;
    boite.classList.remove("newsletter-popup--compact");
    boite.setAttribute("aria-labelledby", "mp-titre-merci");
    boite.setAttribute("aria-describedby", "mp-code-valeur");
    focaliser($("#mp-titre-merci"));
    signal("inscription");
  });

  function copierTexte(t) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(t);
    return new Promise(function (ok, ko) {
      var z = document.createElement("textarea");
      z.value = t;
      z.setAttribute("readonly", "");
      z.style.position = "fixed";
      z.style.opacity = "0";
      boite.appendChild(z);
      z.select();
      var reussi = false;
      try {
        reussi = document.execCommand("copy");
      } catch (e) {}
      boite.removeChild(z);
      if (reussi) ok();
      else ko();
    });
  }
  copier.addEventListener("click", function () {
    var lbl = copier.querySelector("span"),
      ic = copier.querySelector(".ph");
    copierTexte(CONFIG.code).then(
      function () {
        copier.classList.add("newsletter-popup__copy--copied");
        lbl.textContent = "Copié";
        ic.className = "ph ph-check";
        $("#mp-annonce").textContent = "Code " + CONFIG.code + " copié.";
        signal("copie");
        setTimeout(function () {
          copier.classList.remove("newsletter-popup__copy--copied");
          lbl.textContent = "Copier";
          ic.className = "ph ph-copy";
        }, 2400);
      },
      function () {
        var r = document.createRange();
        r.selectNodeContents($("#mp-code-valeur"));
        var s = window.getSelection();
        s.removeAllRanges();
        s.addRange(r);
        $("#mp-annonce").textContent = "Code sélectionné, copiez-le avec votre clavier.";
      },
    );
  });

  $(".newsletter-popup__close").addEventListener("click", function () {
    fermer("croix");
  });
  $(".newsletter-popup__continue").addEventListener("click", function () {
    fermer("continuer");
  });
  $(".newsletter-popup__next").addEventListener("click", function () {
    boite.classList.remove("newsletter-popup--compact");
    champ.focus();
    signal("etape-2");
  });
  voile.addEventListener("click", function () {
    fermer("voile");
  });
  onglet.querySelector(".newsletter-popup-tab__open").addEventListener("click", function () {
    ouvrir("onglet");
  });
  onglet.querySelector(".newsletter-popup-tab__close").addEventListener("click", function () {
    etat.ongletReduit = true;
    garder();
    reduireOnglet(true);
    focaliser(onglet.querySelector(".newsletter-popup-tab__open"));
    signal("onglet-reduit");
  });

  document.addEventListener("keydown", function (e) {
    if (!ouverte) return;
    if (e.key === "Escape" || e.key === "Esc") {
      e.preventDefault();
      fermer("echap");
      return;
    }
    if (e.key !== "Tab") return;
    var f = Array.prototype.filter.call(
      boite.querySelectorAll("button, a[href], input, [tabindex]:not([tabindex='-1'])"),
      function (n) {
        return !n.disabled && n.offsetParent !== null;
      },
    );
    if (!f.length) return;
    var premier = f[0],
      dernier = f[f.length - 1];
    if (!boite.contains(document.activeElement)) {
      e.preventDefault();
      premier.focus();
      return;
    }
    if (e.shiftKey && document.activeElement === premier) {
      e.preventDefault();
      dernier.focus();
    } else if (!e.shiftKey && document.activeElement === dernier) {
      e.preventDefault();
      premier.focus();
    }
  });

  var enAttente = null,
    declenche = false;
  function autoPermis() {
    if (etat.inscrit || session.ouvert) return false;
    return !(etat.revoir && Date.now() < etat.revoir);
  }
  function declencher(origine) {
    if (declenche || ouverte || !autoPermis()) return;
    if (Date.now() - debutPage < CONFIG.minSurPage && origine !== "sortie") return;
    if (bloque()) {
      if (origine === "sortie" || enAttente) return;
      var depuis = Date.now();
      enAttente = setInterval(function () {
        if (Date.now() - depuis > 60000) {
          clearInterval(enAttente);
          enAttente = null;
          return;
        }
        if (!bloque()) {
          clearInterval(enAttente);
          enAttente = null;
          declencher(origine);
        }
      }, 1000);
      return;
    }
    declenche = true;
    ouvrir(origine);
  }
  function partLue() {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    return h > 0 ? window.scrollY / h : 0;
  }

  var ongletPage1 = false,
    defilementPrevu = false,
    assezLu = false;
  function tenter() {
    if (assezLu && Date.now() - session.debut >= CONFIG.delaiSession) declencher("regle");
  }
  window.addEventListener(
    "scroll",
    function () {
      if (defilementPrevu) return;
      defilementPrevu = true;
      requestAnimationFrame(function () {
        defilementPrevu = false;
        if (!onglet.hidden) placerOnglet();
        var p = partLue();
        if (mobile.matches && session.pages <= 1 && !ongletPage1 && p >= CONFIG.ongletMobilePage1 && autoPermis()) {
          ongletPage1 = true;
          montrerOnglet(true);
        }
        if (p >= CONFIG.defilementRegle) {
          assezLu = true;
          tenter();
        }
      });
    },
    { passive: true },
  );

  function demarrer() {
    montrerOnglet(false);
    if (!autoPermis()) return;
    if (partLue() >= CONFIG.defilementRegle) assezLu = true;
    setTimeout(tenter, Math.max(0, CONFIG.delaiSession - (Date.now() - session.debut)) + 50);
  }

  window.MdsPopup = {
    ouvrir: function () {
      ouvrir("manuel");
    },
    fermer: function () {
      fermer("manuel");
    },
    onglet: function () {
      montrerOnglet(true);
    },
    reinitialiser: function () {
      try {
        localStorage.removeItem("mds-popup");
        if (sess) sess.removeItem("mds-popup-session");
      } catch (e) {}
    },
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", demarrer);
  else demarrer();
})();
